import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";

import { InputNumber } from 'primereact/inputnumber';
import { InputText } from "primereact/inputtext";
import { Button } from "../../../../components/ui/Button";


const CornerAreaControl = ({
    layer = false, area, setArea
}) => {
    const { formState: { errors }, control, reset, setValue } = useForm();

    useEffect(() => {
        // Sync React Hook values with the area state

        setValue(`start_margin`, area.start_margin);
        setValue(`top_margin`, area.top_margin);
        setValue(`width`, area.width);
        setValue(`height`, area.height);

    }, [area]);

    const handleSmartInputChange = (field, value) => {

        let updatedValue = parseFloat(value) || 0;

        updatedValue = Math.min(100, Math.max(0, updatedValue));

        if (field === "start_margin") {
            const newWidth = Math.max(0, area.start_margin + area.width - updatedValue);
            setArea({ ...area, "start_margin": updatedValue, "width": Math.min(100, newWidth) })

        } else if (field === "width") {

            const newStartMargin = Math.min(100, 100 - updatedValue,);
            setArea({ ...area, "width": updatedValue, "start_margin": newStartMargin })

        } else if (field === "top_margin") {


            const newHeight = Math.max(0, area.top_margin + area.height - updatedValue);


            setArea({
                ...area,
                "top_margin": updatedValue,
                "height": Math.min(100, newHeight),
            });

        } else if (field === "height") {
            const newTopMargin = Math.min(100, 100 - updatedValue,);

            setArea({
                ...area,
                "height": updatedValue,
                "top_margin": newTopMargin,
            });
        }
    };


    const resetArea = () => {
        setArea({ "height": 100, "top_margin": 0, "width": 100, "start_margin": 0 });
    }


    return (



        <div className={`flex w-100 items-center gap-2 mt-3 ${layer ? "flex-wrap justify-center" : ""}`}>
            {/* Start Margin (X) */}
            <fieldset className={`border border-gray-300 rounded flex flex-col items-center ${layer ? "w-[45%]" : "w-25"} relative max-w-[200px]`}>
                <legend className="text-xs px-1 absolute -top-2 left-2 bg-gray-50 w-auto">
                    X %
                </legend>
                <Controller
                    name={`start_margin`}
                    control={control}
                    defaultValue={area?.start_margin ? area?.start_margin : 0}
                    render={({ field }) => (
                        <InputNumber
                            {...field}
                            minFractionDigits={1}
                            inputClassName="w-25"
                            maxFractionDigits={2}
                            // onFocus={() => dispatch(setSelectedArea(area))}
                            value={field.value}
                            onChange={(e) => {
                                const value = e.value;
                                // setArea({ ...area, "start_margin": value })
                                setValue(`start_margin`, value);
                                handleSmartInputChange("start_margin", value);
                            }}
                        />
                    )}
                />
            </fieldset>
            {/* Top Margin (Y) */}
            <fieldset className={`border border-gray-300 rounded flex flex-col items-center ${layer ? "w-[45%]" : "w-25"} relative max-w-[200px]`}>
                <legend className="text-xs px-1 absolute -top-2 left-2 bg-gray-50 w-auto">
                    Y %
                </legend>
                <Controller
                    name={`top_margin`}
                    control={control}
                    defaultValue={area?.top_margin ? area?.top_margin : 0}
                    render={({ field }) => (
                        <InputNumber
                            {...field}
                            minFractionDigits={1}
                            inputClassName="w-25"
                            maxFractionDigits={2}
                            // onFocus={() => dispatch(setSelectedArea(area))}
                            value={field.value}
                            onChange={(e) => {
                                const value = e.value;
                                // setArea({ ...area, "top_margin": value })
                                setValue(`top_margin`, value);
                                handleSmartInputChange("top_margin", value);
                            }}
                        />
                    )}
                />
            </fieldset>
            {/* Width */}
            <fieldset className={`border border-gray-300 rounded flex flex-col items-center ${layer ? "w-[45%]" : "w-25"} relative max-w-[200px]`}>
                <legend className="text-xs px-1 absolute -top-2 left-2 bg-gray-50 w-auto">
                    Width %
                </legend>
                <Controller
                    name={`width`}
                    control={control}
                    defaultValue={area?.width ? area?.width : 100}
                    render={({ field }) => (
                        <InputNumber
                            {...field}
                            inputClassName="w-25"
                            minFractionDigits={1}
                            maxFractionDigits={2}
                            // onFocus={() => dispatch(setSelectedArea(area))}
                            value={field.value}
                            onChange={(e) => {
                                const value = e.value;
                                // setArea({ ...area, "width": value })

                                setValue(`width`, value);
                                handleSmartInputChange("width", value);
                            }}
                        />
                    )}
                />
            </fieldset>
            {/* Height */}
            <fieldset className={`border border-gray-300 rounded flex flex-col items-center ${layer ? "w-[45%]" : "w-25"} relative max-w-[200px]`}>
                <legend className="text-xs px-1 absolute -top-2 left-2 bg-gray-50 w-auto">
                    Height %
                </legend>
                <Controller
                    name={`height`}
                    control={control}
                    defaultValue={area?.height ? area?.height : 100}
                    render={({ field }) => (
                        <InputNumber
                            {...field}
                            inputClassName="w-25"
                            minFractionDigits={1}
                            maxFractionDigits={2}
                            value={field.value}
                            // onFocus={() => dispatch(setSelectedArea(area))}
                            onChange={(e) => {
                                const value = e.value;
                                // setArea({ ...area, "height": value })
                                setValue(`height`, value);
                                handleSmartInputChange("height", value);
                            }}
                        />
                    )}
                />
            </fieldset>

            {!layer &&
                (<Button icon={"pi pi-refresh"} className="p-button-text p-button-secondary" onClick={resetArea} />)}
        </div>



    );
};

export default CornerAreaControl;
